import { render, staticRenderFns } from "./adverse-media-resources.html?vue&type=template&id=8dcacffa&scoped=true&"
import script from "./adverse-media-resources.js?vue&type=script&lang=js&"
export * from "./adverse-media-resources.js?vue&type=script&lang=js&"
import style0 from "./adverse-media-resources.scss?vue&type=style&index=0&id=8dcacffa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcacffa",
  null
  
)

export default component.exports